import http from "@/common/http.service";
const ROOT_URL = "report/campaign/";
const DOWNLOAD_URL = "report/download-tabs";
const DOMAIN_WISE_REPORT_URL = "report/camp-domain-report-clickhouse";
const CLICK_MAP_URL = "panel/clickmap";

const INBOX_REPORT_URL = "panel/inbox-tracking";
export default {
  fetchItems(params, cb) {
    http.post(ROOT_URL, params).then(function (response) {
      var data = {
        items: response.data.listdata.report_data,
        total: response.data.listcount,
        allowInbox: response.data.allowInbox,
      };
      cb(data);
    });
  },
  exportItems(params, { name }) {
    return http.post(ROOT_URL, params, name);
  },
  downLoad(data) {
    return http.downLoad(DOWNLOAD_URL, data);
  },
  fetchDoaminWiseReport(params, cb) {
    http.post(DOMAIN_WISE_REPORT_URL, params).then(function (response) {
      var data = response.data.data;
      cb(data);
    });
  },
  fetchClickMapData(params) {
    return http.post(CLICK_MAP_URL, params).then(function (response) {
      if (params.download === 1) {
        return response;
      }
      return response.data;
    });
  },
  fetchInboxReport(params, cb) {
    http.post(INBOX_REPORT_URL, params).then(function (response) {
      var data = response;
      cb(data);
    });
  },
};
